export default "__VITE_ASSET__CwrTt$E2__"